"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// adapted from: https://gist.github.com/DiegoSalazar/4075533

var luhnCheck = function luhnCheck(val) {
  // accept only digits, dashes or spaces
  if (/[^0-9-\s]+/.test(val)) {
    return false;
  }

  // the Luhn Algorithm
  var nCheck = 0;
  var nDigit = 0;
  var bEven = false;
  var value = val.replace(/\D/g, '');
  for (var n = value.length - 1; n >= 0; n -= 1) {
    var cDigit = value.charAt(n);
    nDigit = parseInt(cDigit, 10);
    if (bEven) {
      nDigit *= 2;
      if (nDigit > 9) {
        nDigit -= 9;
      }
    }
    nCheck += nDigit;
    bEven = !bEven;
  }

  // return true if valid number
  return nCheck % 10 === 0;
};
var _default = exports["default"] = luhnCheck;